export type NetworkLogEntry = {
  traceId: string;
  at: string;
  method: string;
  url: string;
  status?: number;
  durationMs?: number;
  requestSummary?: string;
  responseSummary?: string;
};

const RING_CAPACITY = 50;
const ring: NetworkLogEntry[] = [];

export function pushNetworkLog(entry: NetworkLogEntry) {
  ring.push(entry);
  while (ring.length > RING_CAPACITY) ring.shift();
}

export function getNetworkLogSnapshot(): NetworkLogEntry[] {
  return ring.slice();
}
